function initClipboardCopier(
  fieldId: string,
  buttonId: string,
): { field: HTMLInputElement; button: HTMLButtonElement } {
  const field = document.querySelector<HTMLInputElement>(`#${fieldId}`);
  const button = document.querySelector<HTMLButtonElement>(`#${buttonId}`);

  if (!field) {
    throw new Error(`Couldn't initiate clipboard copier on ${fieldId}, ${buttonId}. Field missing`);
  }

  if (!button) {
    throw new Error(
      `Couldn't initiate clipboard copier on ${fieldId}, ${buttonId}. Button missing`,
    );
  }

  field.addEventListener('click', () => {
    field.select();
  });

  field.addEventListener('blur', () => {
    const selection = window.getSelection();
    selection && selection.empty();
  });

  button.addEventListener('click', () => {
    field.select();
    document.execCommand('Copy');
    const selection = window.getSelection();
    selection && selection.empty();
  });

  return { field, button };
}

export default initClipboardCopier;
